import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function PauseIcon(props) {
  return (
    <SvgIcon viewBox="0 0 20 20" {...props}>
      <path
        d="M15.8194 14.8086C15.8194 15.1379 15.7054 15.4166 15.4774 15.6446C15.2494 15.8726 14.9644 15.9929 14.6224 16.0056H12.2284C11.899 16.0056 11.614 15.8852 11.3734 15.6446C11.1327 15.4039 11.0187 15.1252 11.0314 14.8086V5.21357C11.0314 4.88424 11.1454 4.59924 11.3734 4.35857C11.6014 4.11791 11.8864 4.00391 12.2284 4.01658H14.6224C14.9517 4.01658 15.2367 4.13057 15.4774 4.35857C15.718 4.58657 15.832 4.87157 15.8194 5.21357V14.8086ZM8.63736 14.8086C8.63736 15.1379 8.51703 15.4166 8.27636 15.6446C8.0357 15.8726 7.75703 15.9929 7.44036 16.0056H5.04636C4.71703 16.0056 4.43203 15.8852 4.19136 15.6446C3.9507 15.4039 3.8367 15.1252 3.84936 14.8086V5.21357C3.84936 4.88424 3.96336 4.59924 4.19136 4.35857C4.41936 4.11791 4.70436 4.00391 5.04636 4.01658H7.44036C7.7697 4.01658 8.04836 4.13057 8.27636 4.35857C8.50436 4.58657 8.6247 4.87157 8.63736 5.21357V14.8086Z"
        fill="#4E83BC"
      />
    </SvgIcon>
  );
}

export default PauseIcon;
